import i18n from "@/langs/i18n";

export function getAll() {
  return [
    {
      value: 1,
      name: "Percent",
      text: `${i18n.t("option.ocardPromotionType.Percent")}`,
    },
    {
      value: 2,
      name: "Price",
      text: `${i18n.t("option.ocardPromotionType.Price")}`,
    },
    {
      value: 3,
      name: "Redeem",
      text: `${i18n.t("option.ocardPromotionType.Redeem")}`,
    },
  ];
}
export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}
export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
